import { push as NavigationSidebar } from 'react-burger-menu';
import React, {useContext, useEffect, useState} from 'react';
import {SidebarItemPair} from "app/shared/layout/sidebar/configuration/sidebar-configuration";
import {Button} from "edozvola-frontend-lib/dist/ui/components/button";
import {faBars, faX} from "@fortawesome/free-solid-svg-icons";
import {MainSidebarContext} from "app/shared/layout/main-sidebar/main-sidebar-context";
import {useLocation, useNavigate} from "react-router-dom";
import {declassify} from "app/shared/util/common";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import './main-sidebar-wrapper.scss';
import {onDownloadContentFile} from "app/shared/util/redozvola-util";

const MainSidebarWrapper = ({children, navigationItems = [] as SidebarItemPair[], isOpen = true}) => {

  const { sidebarItem, setSidebarItem } = useContext(MainSidebarContext);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const onNavItemClicked = (item: SidebarItemPair) => {
    if (isPageEqualToNavItem(item)) {
      return;
    }
    setSidebarItem(item);
    if (item.newTab) {
      setShowConfirmationModal(true);
    }
    else {
      navigate(item.sidebarItemPath);
    }
  }

  const navigateToDestination = (destination: SidebarItemPair) => {
    if (destination.newTab) {
      window.open(destination.sidebarItemPath, '_blank', 'rel=noopener=true,noreferrer=true,popup=false');
      setShowConfirmationModal(false);
    }
    else {
      navigate(destination.sidebarItemPath);
    }
  }

  const isPageEqualToNavItem = (item: SidebarItemPair) => {
    let sidebarPath: string;

    if (item.sidebarItemPath.startsWith('/')) {
      sidebarPath = location.pathname;
    }
    else {
      sidebarPath = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
    }
    return sidebarPath === item.sidebarItemPath;
  }

  useEffect(() => {
    const item = navigationItems.filter(item => isPageEqualToNavItem(item));
    if (item?.length > 0) {
      setSidebarItem(item);
    }
  }, []);

  const onDownloadStatement = (e) => {
    onDownloadContentFile(e,
      "content/pdf/edozvola_izjava_o_pristupacnosti.pdf",
      "edozvola_izjava_o_pristupacnosti.pdf"
    );
  }

  return (
    <div style={{height: '100%'}} className={'page-content'} id={'outer-container'}>
      <NavigationSidebar
        noOverlay
        disableCloseOnEsc
        isOpen={isOpen}
        customCrossIcon={<Button size="sm" appendIcon={faX} className={'hidden-button'}/>}
        customBurgerIcon={<Button size="sm" prependIcon={faBars}/>}
        pageWrapId={'page-wrap'}
        outerContainerId={'outer-container'}
        id={'navigation-sidebar'}
      >
        <>
          <div style={{paddingBottom: '70px'}}>
          {navigationItems?.map((item) =>
              item.visible && (
                <>
                  <a key={item.sidebarItemKey}
                     className={declassify({
                       'readonly-item': item.readonly,
                       'bm-item': true,
                       'navigation-item-active': isPageEqualToNavItem(item)
                     })}
                     onClick={() => !item.readonly ? onNavItemClicked(item) : null}>
                    {item.sidebarItemValue}
                  </a>
                  {item.children && item.children.length > 0 &&
                    <div className="navigation-child-wrapper">
                      {item.children.map((childItem: SidebarItemPair) => (
                        <a key={childItem.sidebarItemKey}
                           className={declassify({
                             'bm-item': true,
                             'navigation-item-active': isPageEqualToNavItem(childItem)
                           })}
                           onClick={() => onNavItemClicked(childItem)}>
                          {childItem.sidebarItemValue}
                        </a>
                      ))}
                    </div>
                  }
                </>
              )
          )}
          </div>
          <div className="sidebar-statement-link text-center">
            <a
              className="bm-item"
              onClick={e => onDownloadStatement(e)}
              href={`content/pdf/izjava-o-pristupacnosti.pdf`}
              target="_blank"
            >
              Izjava o pristupačnosti
            </a>
          </div>
        </>
      </NavigationSidebar>
      <div id={'page-wrap'} style={{marginRight: 0, paddingRight: '320px'}} className={declassify({
        'navbar-content': true,
        'navbar-closed': !isOpen,
        'navbar-opened': isOpen,
        'bg-white': true
      })}>
        {children}
      </div>
      <Modal centered isOpen={showConfirmationModal}>
        <ModalHeader>Otvaranje u novom prozoru</ModalHeader>
        <ModalBody>
          Stranica će se otvoriti u novom prozoru. Želite li nastaviti?
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label={'Odustani'} outline onClick={() => setShowConfirmationModal(false)}/>
          <Button size={'lg'} label={'Nastavi'} color={'info'} onClick={() => navigateToDestination(sidebarItem)}/>
        </ModalFooter>
      </Modal>
    </div>
  );
};


export default MainSidebarWrapper;
